<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      md6
    >
      <app-reference
        v-model="company"
        :label="companyLabel"
        resource="courier-services"
        component-name="CourierService"
        :outline="true"
        :height-field="44"
        :disabled="disabled"
        :rules="[rules.required]"
        :required="isCourierType ? true : false"
        :error="isCompany"
        class="my-2 ml-2"
      />
    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-text-field
        v-model="waybillNumber"
        label="Номер ТТН"
        hide-details
        outline
        height="44"
        class="my-2 ml-2"
        :disabled="disabled"
        @blur="change"
      />
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: ["value", "disabled", "isCourierType"],
  data() {
    return {
      company: null,
      waybillNumber: "",
      rules: {
        required: (v) => (!!v) || "Поле обязательно к заполнению",
      },
    };
  },
  computed: {
    companyLabel() {
      return this.isCourierType ? "Выберите службу*" : "Выберите службу";
    },
    isCompany() {
      return this.isCourierType && !this.company;
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.company = this.value.company;
          this.waybillNumber = this.value.waybillNumber;
        } else {
          this.company = null;
          this.waybillNumber = "";
        }
      },
      immediate: true,
    },
    company() {
      this.change();
    },
  },
  methods: {
    change() {
      this.$emit("change", {
        company: this.company,
        waybillNumber: this.waybillNumber,
      });
    },
  },
};
</script>
